(function($, undefined) {
	
	'use strict';
	
	var init = function () {
		
		var defaultPluginSettings = "paste link textcolor";
		
		var defaultToolbarSettings = "formatselect | bold italic underline strikethrough forecolor | link | removeformat";
		
		var settings = {
		    selector: 'textarea.editable:not([id^="mce_"])',
		    menubar: false,
		    plugins: defaultPluginSettings,
		    toolbar: defaultToolbarSettings,
		    entity_encoding: "raw",
		    // paste_as_text: true,
		    branding: false,
		    paste_retain_style_properties: 'all'
		};	
		
		if ($('textarea.editable:not([id^="mce_"])').length > 0) {
			tinyMCE.init(settings);
		}
	};
	
	$(window).ready(function () {
		init();
	});
	
})(jQuery);
